// frontend/src/pages/WorkOptimizationSessionNewPage.tsx
import React, { useEffect, useState } from 'react';
import { Button, Form, Input, Select, Typography, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import { WorkType, getWorkTypes, createSession } from '../api/workOptimization';
import api from '../api/client';

const { Title } = Typography;

interface Workplace { id: number; name: string; }
interface Individual { id: number; first_name: string; last_name: string; }

const WorkOptimizationSessionNewPage: React.FC = () => {
  const [form] = Form.useForm();
  const [workTypes, setWorkTypes] = useState<WorkType[]>([]);
  const [workplaces, setWorkplaces] = useState<Workplace[]>([]);
  const [individuals, setIndividuals] = useState<Individual[]>([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    getWorkTypes().then(setWorkTypes);
    api.get('/workplaces').then(r => setWorkplaces(r.data));
    api.get('/individuals?per_page=200').then(r => setIndividuals(r.data.items ?? r.data));
  }, []);

  const handleSubmit = async (values: any) => {
    setLoading(true);
    try {
      const session = await createSession(values);
      navigate(`/work-optimization/session/${session.id}/timing`);
    } catch {
      message.error('Ошибка при создании сессии');
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: 480 }}>
      <Title level={4}>Новая сессия хронометража</Title>
      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Form.Item name="work_type_id" label="Тип работы" rules={[{ required: true, message: 'Выберите тип работы' }]}>
          <Select placeholder="Выберите тип работы" showSearch optionFilterProp="label"
            options={workTypes.map(w => ({ value: w.id, label: w.name }))} />
        </Form.Item>
        <Form.Item name="workplace_id" label="Рабочее место">
          <Select placeholder="Выберите рабочее место" allowClear showSearch optionFilterProp="label"
            options={workplaces.map(w => ({ value: w.id, label: w.name }))} />
        </Form.Item>
        <Form.Item name="individual_id" label="Сотрудник (наблюдаемый)">
          <Select placeholder="Выберите сотрудника" allowClear showSearch optionFilterProp="label"
            options={individuals.map(i => ({ value: i.id, label: `${i.last_name} ${i.first_name}` }))} />
        </Form.Item>
        <Form.Item name="car_info" label="Автомобиль">
          <Input placeholder="Марка, модель, год (опционально)" />
        </Form.Item>
        <Form.Item name="notes" label="Примечания">
          <Input.TextArea rows={2} />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading} size="large" block>
            Начать хронометраж
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default WorkOptimizationSessionNewPage;
